<template>
    <div class="PracticeResultView">
        <GameScrollableWithStickyHeader
            ref="scrollContainer"
            class="scrollContainer"
            :sticky-height="headerStickyHeight"
            @scroll="onHeaderScroll"
        >
            <div slot="header" class="header" :style="{ backgroundImage: `url(${theme.coverImage})` }">
                <div ref="title" class="title">
                    {{ $t('completed') }}
                </div>
                <div ref="subtitle" class="subtitle" :style="{ color: theme.primaryColor }">
                    <!-- <span v-if="stars === 3">{{ $t('perfectScore') }}</span>
          <span v-else>{{ $t('passedScore') }}</span> -->
                </div>

                <div ref="targetHeightHelper" class="starsContainer targetHeightHelper">
                    <!-- <div class="stars" ref="stars">
            <svgicon class="Star" :class="{ isFull: star <= stars}" v-for="star of 3" icon="star" :key="star"/>
          </div> -->
                </div>
            </div>

            <div slot="body" ref="body" class="body">
                <div ref="continueButton" class="stickyContainer" :style="{ top: `${headerStickyHeight2}px` }">
                    <div
                        v-if="fail"
                        class="continueButton --global-clickable"
                        :style="{ backgroundColor: theme.primaryColor, color: theme.textColorOnPrimaryColor }"
                        @click="retryPractice()"
                    >
                        {{ $t('retry') }}
                    </div>
                    <div
                        v-else
                        class="continueButton --global-clickable"
                        :style="{ backgroundColor: theme.primaryColor, color: theme.textColorOnPrimaryColor }"
                        @click="exit()"
                    >
                        {{ $t('backToSystem') }}
                    </div>
                </div>

                <StandardSection class="timeSection" :label="$t('timeHeader')">
                    <div class="times">
                        <div class="Time">
                            <div>{{ $t('learningTime') }}</div>
                            <div>
                                <span class="Time__value">{{
                                    (sessionReport.memorizeTimeUsed / 1000).toFixed(1)
                                }}</span>
                                {{ $t('seconds') }}
                            </div>
                        </div>

                        <div class="Time">
                            <div>{{ $t('memoryTime') }}</div>
                            <div>
                                <span class="Time__value">{{ (sessionReport.quizTimeUsed / 1000).toFixed(1) }}</span>
                                {{ $t('seconds') }}
                            </div>
                        </div>
                    </div>
                </StandardSection>

                <StandardSection class="quizDetails" :label="$t('yourAnswers')">
                    <SessionReport :items="sessionReport.items" />
                </StandardSection>
            </div>
        </GameScrollableWithStickyHeader>

        <!-- <div class="top">
      <div class="exitButton --global-clickable" @click="exit()">Exit</div>
    </div> -->
        <GameHeader ref="top" class="top" :countdown="-1" @request-exit="exit()" />
    </div>
</template>

<translations>
  perfectScore: 'Perfect Score'
  perfectScore_no: 'Perfekt'
  passedScore: 'Well done'
  passedScore_no: 'Bra jobba'
  yourAnswers: 'Your answers'
  yourAnswers_no: 'Dine svar'
  completed: 'Completed'
  completed_no: 'Ferdig'
  retry: 'Retry'
  retry_no: 'Prøv på nytt'
  backToSystem: 'Back to Name System'
  backToSystem_no: 'Tilbake til Navnesystemet'
  timeHeader: 'Your time'
  timeHeader_no: 'Tiden din'
  learningTime: 'Memorization Time'
  learningTime_no: 'Memoreringstid'
  memoryTime: 'Recall Time'
  memoryTime_no: 'Husketid'
  seconds: 'sec'
  seconds_no: 'sek'
</translations>

<script>
import { TimelineLite } from 'gsap';

import GameScrollableWithStickyHeader from '@/components/GameScrollableStickyHeader';
import GameHeader from '@/modules/games-shared/components/GameHeader';

import StandardSection from '../components/StandardSection';
import SessionReport from '../components/SessionReport';
import gameHelper from '@/modules/games-shared/game-helper';

export default {
    name: 'LevelSuccessView',
    components: { GameScrollableWithStickyHeader, StandardSection, SessionReport, GameHeader },
    props: {
        gameId: {
            type: String,
            required: true
        },
        sessionId: {
            type: String,
            required: true
        }
    },
    inject: ['theme'],
    data() {
        return {
            blockInteraction: false,
            headerStickyHeight2: 0
        };
    },
    computed: {
        stars() {
            return 3;
        },
        fail() {
            return true;
        }
    },
    created() {
        this.session = gameHelper.sessions[this.sessionId];
        this.sessionReport = this.session.generateReport(this.$t.bind(this));
    },
    mounted() {
        this.headerStickyHeight2 = this.headerStickyHeight();
        let tl = new TimelineLite();
        tl.pause();
        tl.seek(0);

        tl.staggerFromTo(
            [this.$refs.title, this.$refs.subtitle],
            1,
            {
                opacity: 1
            },
            {
                opacity: 0
            },
            0
        );

        // tl.fromTo(this.$refs.stars, 1, {
        //   // opacity: 1,
        //   yPercent: 50,
        //   scale: 1
        // }, {
        //   // opacity: 0,
        //   yPercent: 0,
        //   scale: 0.7
        // }, 0)

        tl.fromTo(
            this.$refs.body,
            1,
            {
                // opacity: 1,
                paddingTop: '2em'
            },
            {
                // opacity: 0,
                paddingTop: '0em'
            },
            0
        );
        this.tl = tl;

        this.$refs.scrollContainer.$el.addEventListener('scroll', this.onBodyScroll);
    },
    beforeDestroy() {
        this.tl.kill();
        this.$refs.scrollContainer.$el.removeEventListener('scroll', this.onBodyScroll);
    },
    methods: {
        headerStickyHeight() {
            if (this.$refs.targetHeightHelper) {
                return this.$refs.targetHeightHelper.clientHeight;
            } else {
                return 0;
            }
        },
        onHeaderScroll(fraction) {
            this.tl.time(fraction);
            if (fraction === 1) {
                this.stickySectionScrollTopTrigger = this.$refs.continueButton.offsetTop - this.headerStickyHeight2;
            }
        },
        onBodyScroll(event) {
            if (event.srcElement.scrollTop >= this.stickySectionScrollTopTrigger) {
                this.$refs.continueButton.classList.add('sticking');
            } else {
                this.$refs.continueButton.classList.remove('sticking');
            }
        },
        exit() {
            this.$router.push(this.session.exitUrl);
        },
        retryPractice() {
            gameHelper.createPracticeSession({
                gameId: this.gameId,
                exitUrl: this.session.exitUrl,
                sessionOptions: this.session.generateSessionOptionsForRetry(),
                navigate: true
            });
        }
    }
};
</script>

<style scoped lang="scss">
.PracticeResultView {
    display: flex;
    flex-direction: column;

    $transitionDuration: 0.5s;
    &.banner_to_none-leave-active .body,
    &.banner_to_none-leave-active .header > * {
        transition: opacity $transitionDuration;
    }
    &.banner_to_none-leave-to .body,
    &.banner_to_none-leave-to .header > * {
        opacity: 0;
    }

    &.blockInteraction::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
    }
}
.header {
    height: 12em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: rgba(black, 0.5);

    background-size: cover;
    background-position: center bottom;
}
.targetHeightHelper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: $memogeniusShared-headerHeight;
    display: flex;
    align-items: center;
    justify-content: center;
}
.top {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
}
.title {
    font-size: 140%;
}
.subtitle {
    margin-top: 0.5em;
}
.body {
    flex: 1;
    padding: 2em;
    padding-top: 0;
    // padding-top: 12em;
    display: flex;
    flex-direction: column;

    // overflow-y: auto;

    & > * {
        flex-shrink: 0;
    }
}

// .stars {
//   display: flex;
//   justify-content: center;
// }
//
// .Star {
//   $size: 3em;
//   width: $size;
//   height: $size;
//   // fill: rgba(white, 0.1);
//   fill: #464392; // Color for game-faces
//   margin: 0 0.3em;
//
//   &.isFull {
//     fill: #F2C500;
//   }
// }

.stats {
    display: flex;
    justify-content: space-between;

    margin-top: 1em;
}
.StatsItem {
}
.StatsItemLabel {
    opacity: 0.5;
    margin-bottom: 0.2em;
}
.StatsItemValue {
    font-size: 120%;
    color: white;
}

.stickyContainer {
    position: sticky;
    top: 12em;
    margin-top: 2em;

    &.sticking {
        .continueButton {
            margin-left: -2em;
            margin-right: -2em;
            border-radius: 0;
        }
    }
}
.continueButton {
    padding: 1em 2em;
    color: white;
    align-self: stretch;
    text-align: center;
    border-radius: 0.2em;

    $transitionDuration: 0.2s;
    transition: margin $transitionDuration, border-radius $transitionDuration;
}
.exitButton {
    align-self: center;
}
.spacer {
    flex: 1;
}
.times {
    display: flex;
    margin-top: 1em;
}
.Time {
    flex: 1;
    background: rgba(black, 0.2);
    padding: 1em;
    border-radius: 0.5em;

    &:not(:first-child) {
        margin-left: 1em;
    }
}
.Time__value {
    font-size: 140%;
}

.quizDetails {
    margin-top: 2em;
}

.timeSection {
    margin-top: 3em;
}
</style>
